import { BaseMapData } from './BaseMapData.ts';
import { StoreExpansionType, LobbyImage, ModeSettingEnum, ScenarioSettingEnum, MapSettingEnum } from '@colonist/types';
export class MapDataSS1HeadingForNewShores56P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [
            StoreExpansionType.Seafarers56P,
            StoreExpansionType.CitiesAndKnightsSeafarers56P
        ], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.SS1HeadingForNewShores56P, this.name = {
            key: 'strings:colonistCommon.gameMaps.seafarers.headingForNewShores',
            options: {
                count: 6
            }
        }, this.image = LobbyImage.MapSS1HeadingForNewShores56PPreview, this.compatibleGameModes = [
            ModeSettingEnum.Seafarers4P,
            ModeSettingEnum.Seafarers56P,
            ModeSettingEnum.CitiesAndKnightsSeafarers4P,
            ModeSettingEnum.CitiesAndKnightsSeafarers56P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = true, this.numberOfLandTiles = 40, this.scenario = ScenarioSettingEnum.SS1HeadingForNewShores;
    }
}
export class MapDataSS2SixIslands56P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [
            StoreExpansionType.Seafarers56P,
            StoreExpansionType.CitiesAndKnightsSeafarers56P
        ], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.SS2SixIslands56P, this.name = {
            key: 'strings:colonistCommon.gameMaps.seafarers.sixIslands'
        }, this.image = LobbyImage.MapSS2SixIslands56PPreview, this.compatibleGameModes = [
            ModeSettingEnum.Seafarers4P,
            ModeSettingEnum.Seafarers56P,
            ModeSettingEnum.CitiesAndKnightsSeafarers4P,
            ModeSettingEnum.CitiesAndKnightsSeafarers56P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = true, this.numberOfLandTiles = 32, this.scenario = ScenarioSettingEnum.SS2TheFourIslands;
    }
}
export class MapDataSS3FogIslands56P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [
            StoreExpansionType.Seafarers56P,
            StoreExpansionType.CitiesAndKnightsSeafarers56P
        ], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.SS3FogIslands56P, this.name = {
            key: 'strings:colonistCommon.gameMaps.seafarers.fogIslands',
            options: {
                count: 6
            }
        }, this.image = LobbyImage.MapSS3FogIslands56PPreview, this.compatibleGameModes = [
            ModeSettingEnum.Seafarers4P,
            ModeSettingEnum.Seafarers56P,
            ModeSettingEnum.CitiesAndKnightsSeafarers4P,
            ModeSettingEnum.CitiesAndKnightsSeafarers56P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = true, this.numberOfLandTiles = 39, this.scenario = ScenarioSettingEnum.SS3TheFogIslands;
    }
}
export class MapDataSS4ThroughTheDesert56P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [
            StoreExpansionType.Seafarers56P,
            StoreExpansionType.CitiesAndKnightsSeafarers56P
        ], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.SS4ThroughTheDesert56P, this.name = {
            key: 'strings:colonistCommon.gameMaps.seafarers.throughTheDesert',
            options: {
                count: 6
            }
        }, this.image = LobbyImage.MapSS4ThroughTheDesert56PPreview, this.compatibleGameModes = [
            ModeSettingEnum.Seafarers4P,
            ModeSettingEnum.Seafarers56P,
            ModeSettingEnum.CitiesAndKnightsSeafarers4P,
            ModeSettingEnum.CitiesAndKnightsSeafarers56P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = true, this.numberOfLandTiles = 43, this.scenario = ScenarioSettingEnum.SS4ThroughTheDesert;
    }
}
